module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hant/5-2ec18548b5e2434c78dc32e3cb5a26b3.jpg";